import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessage,
    SettingState,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import * as tios from './tios';

export default class Modbus extends BaseFeature {
    constructor() {
        super();
        this.name = 'Modbus';
        this.id = 'modbus';
        this.files = [
            'libraries/modbus/modbus.tbs',
            'libraries/modbus/modbus.tbh',
        ];
    }

    getDependencies() {
        const dependencies = [
            'sock',
        ];

        return dependencies;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
